import React, { useMemo } from "react";
import { BarChart } from "../Visualization/BarChart";
import { useAppContext } from "../../contexts/AppContext";

function BasketBarChart({ custIndex, title, filters, kpiSettings, subtitle = undefined, reference = {}, chartProps = {}, data = [], displayMode, rolledForwardDataPoints = new Set(), ...props }) {
    const { getColorByCustId, getCustlabelByCustId } = useAppContext();
    const barsColor = getColorByCustId(custIndex);

    const categories = useMemo(() => data?.map((dp) => getCustlabelByCustId(dp.title)), [data, getCustlabelByCustId]);

    const series = useMemo(() => {
        return data.length > 0
            ? [
                  {
                      name: custIndex,
                      data: data?.map((dp) => {
                          const isRolledForward = displayMode.key === "player" ? rolledForwardDataPoints.has(`${dp.title}|${custIndex}`) : rolledForwardDataPoints.has(`${custIndex}|${dp.title}`);

                          let color = barsColor;
                          //@ts-ignore
                          if (dp.title === reference?.versionStd) {
                              color = "#B2B2B2";
                          } else if (dp.title.length === 3) {
                              color = getColorByCustId(dp.title);
                          }

                          const point = {
                              y: dp.dataPoint,
                              color: color,
                          };

                          if (isRolledForward) {
                              point.dataLabels = {
                                  backgroundColor: "#d9d9d9",
                                  borderRadius: 3,
                                  padding: 2,
                                  color: "black",
                              };
                          }

                          return point;
                      }),
                  },
              ]
            : [];
    }, [data, custIndex, displayMode, rolledForwardDataPoints, barsColor, reference, getColorByCustId]);

    return (
        data.length > 0 && (
            <div key={custIndex} className={`${props.widgetUid ? "border-none" : "border-2 border-gray-300 rounded"}`}>
                <BarChart
                    metadata={{
                        custIndex,
                        displayMode,
                        flag_services: kpiSettings,
                    }}
                    section={"basketbar"}
                    filters={filters}
                    id={"basket-bar-chart"}
                    title={title}
                    subtitle={subtitle}
                    barsColor={barsColor}
                    categories={categories}
                    series={series}
                    referenceLine={{
                        //@ts-ignore
                        value: reference?.value,
                    }}
                    {...chartProps}
                    caption={
                        rolledForwardDataPoints && rolledForwardDataPoints.size > 0
                            ? {
                                  text: '<div style="display: flex; align-items: center; font-size: 10px; color: #666666;"><div style="width: 10px; height: 10px; background-color: #d9d9d9; border-radius: 3px; margin-right: 4px;"></div><span>Data points with gray background are from previous month</span></div>',
                                  useHTML: true,
                                  align: "left",
                                  verticalAlign: "bottom",
                                  y: 15,
                                  x: 10,
                              }
                            : {}
                    }
                    {...props}
                />
            </div>
        )
    );
}
export { BasketBarChart };
